export default function ProcessHero() {
  return (
    <section className="relative pt-40 pb-24 bg-[#f4f2ef] overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <div className="max-w-2xl">
            <div className="flex items-center gap-3 mb-8">
              <div className="w-10 h-px bg-[#b8956a]"></div>
              <span className="text-[#b8956a] text-sm font-medium tracking-[0.2em] uppercase">Our Process</span>
            </div>
            <h1
              className="font-bold text-[#1a1a1a] leading-[1.25] mb-5"
              style={{ fontSize: 'clamp(2rem, 4vw, 2.75rem)' }}
            >
              規劃流程
            </h1>
            <p className="text-[#5a5a5a] leading-[1.75] max-w-xl" style={{ fontSize: '1.1875rem' }}>
              透明、清楚、有條理的合作流程，讓業主從第一次接觸到完工交付，
              全程安心、不迷路，每個關鍵決策都有專業顧問陪伴。
            </p>
          </div>
          {/* Quick Stats */}
          <div className="flex flex-wrap gap-6 lg:gap-8">
            {[
              { num: '6', label: '清楚階段' },
              { num: '1對1', label: '專屬顧問' },
              { num: '全程', label: '進度透明' },
            ].map((s) => (
              <div key={s.label} className="text-center">
                <div
                  className="font-bold text-[#b8956a]"
                  style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: '2.5rem', lineHeight: 1.1 }}
                >
                  {s.num}
                </div>
                <div className="text-[#8a8a8a] text-sm mt-1">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
